export default __webpack_public_path__ + "static/media/svg-6.1c290ac6.svg";